import React, { useState } from "react";
import {
    Box, Button, TextField, Typography, Paper,
    useMediaQuery, CircularProgress, Stack
} from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { useAdminAuth } from "../contexts/AdminAuthContext";
import { useSnackbar } from "../contexts/SnackbarContext";
import apiAdm from "../services/apiAdm";
import { getApiErrorMessage, normalizeAdmin } from "../services/apiUtils";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const { loginAdm } = useAdminAuth();
    const { showSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [loading, setLoading] = useState(false);

    async function handleLogin(e) {
        e.preventDefault();
        setLoading(true);

        try {
            const { data } = await apiAdm.post("/admin/authenticate", { email, password: senha });
            const token = data?.access_token;

            if (!token) {
                showSnackbar("Credenciais inválidas.", "error");
                return;
            }

            loginAdm({}, token);
            const profile = await apiAdm.get("/admin");
            loginAdm(normalizeAdmin(profile.data), token);
            navigate("/administrativo/controle");

        } catch (err) {
            console.error(err);
            showSnackbar(getApiErrorMessage(err, "Falha no login ADM."), "error");
        } finally {
            setLoading(false);
        }
    }

    return (
        <Box sx={{
            minHeight: "100vh",
            bgcolor: "background.default",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            px: 2
        }}>
            <Paper elevation={3} sx={{ p: 4, width: isMobile ? "95%" : 420, borderRadius: 4 }}>
                <Stack spacing={1.2} alignItems="center" mb={2}>
                    <AdminPanelSettingsIcon color="primary" sx={{ fontSize: 48 }} />
                    <Typography variant="h5" sx={{ fontWeight: 800 }}>
                        Área Administrativa
                    </Typography>
                    <Typography variant="body2" color="text.secondary" align="center">
                        Acesso exclusivo para administradores Docen
                    </Typography>
                </Stack>

                <form onSubmit={handleLogin}>
                    <TextField
                        label="E-mail (ADM)"
                        type="email"
                        fullWidth
                        required
                        margin="normal"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={loading}
                    />
                    <TextField
                        label="Senha"
                        type="password"
                        fullWidth
                        required
                        margin="normal"
                        value={senha}
                        onChange={(e) => setSenha(e.target.value)}
                        disabled={loading}
                    />
                    <Button
                        fullWidth
                        variant="contained"
                        type="submit"
                        sx={{ mt: 2, mb: 2, position: "relative" }}
                        disabled={loading}
                    >
                        {loading && (
                            <CircularProgress size={20} sx={{ color: "white", position: "absolute", left: 16 }} />
                        )}
                        <span style={{ marginLeft: loading ? 24 : 0 }}>
                            {loading ? "Entrando..." : "Entrar"}
                        </span>
                    </Button>
                </form>
            </Paper>
        </Box>
    );
}